import React from "react";
import mainStyle from "../styles/mainComponents.module.css";

function InputAuth({ type, value, onChange, onFocus, placeholder, className, name, autoComplete }) {
  return (
    <input
      className={`${mainStyle.inputAuth} ${className}`}
      type={type}
      value={value}
      onChange={onChange}
      onFocus={onFocus}
      placeholder={placeholder}
      name={name}
      autoComplete={autoComplete}
    />
  );
}

export default InputAuth;
